import { motion } from "framer-motion";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { useTranslation } from "@/core/i18n";
import { DateOfBirthField } from "@/modules/onboarding/components/DateOfBirthField/DateOfBirthField";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingBackButton } from "@/modules/onboarding/components/OnboardingBackButton/OnboardingBackButton";
import OnboardingHeaderV3 from "@/modules/onboarding/components/OnboardingScreenHeader/OnboardingHeaderV3";
import { useOnboardingContext } from "@/modules/onboarding/context";
import { Button } from "atoms/button/Button";
import { TextButton } from "atoms/text-button/TextButton";

const V3DateOfBirthPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profile, updateProfileState } = useOnboardingContext();
  const [dobIso, setDobIso] = useState<string | null>(profile.dateOfBirth ?? null);
  const [isValid, setIsValid] = useState<boolean>(false);

  const handleContinue = useCallback(
    async (dateOfBirth?: string | null) => {
      updateProfileState({ dateOfBirth: dateOfBirth ?? undefined });

      navigate("/signin/gender");
    },
    [navigate, updateProfileState],
  );

  return (
    <MobileViewportContainer header={<OnboardingBackButton />}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="flex w-full max-w-sm flex-col gap-9"
      >
        <OnboardingHeaderV3
          title={t("v3DateOfBirthPage.title")}
          subtitle={t("v3DateOfBirthPage.subtitle")}
          align="left"
        />
        <div className="flex flex-col gap-3">
          <DateOfBirthField
            value={dobIso || undefined}
            onChange={setDobIso}
            onValidationChange={setIsValid}
            label={t("v3DateOfBirthPage.label")}
            className="!ring-0 focus:!ring-0"
            labelClassName="hidden"
          />
          <div className="mt-6 flex flex-col items-center gap-4">
            <Button fullWidth onClick={() => handleContinue(dobIso)} disabled={!isValid}>
              {t("common.confirm")}
            </Button>
            <TextButton className="px-3 font-normal" onClick={() => handleContinue()}>
              {t("v3DateOfBirthPage.chooseNotToShare")}
            </TextButton>
          </div>
        </div>
      </motion.div>
    </MobileViewportContainer>
  );
};

export default V3DateOfBirthPage;
